module.exports = __webpack_public_path__ + "static/media/cluster_9.730b0966.webp";